export enum SentDocumentsFilteringPolicy {
    All = 1,
    Sent,
    NotSent
}
